import { DeviceStatusType } from "@common/components/ListDetailViews/DetailView/DeviceCard/const";
import { getStatus } from "@pages/Meeting/DetailView/RealTimeTab/DetailFrame/ParticipantCard/const";
import { Device } from "@services/devices/types";
import { MeetingInstance } from "@services/meetings/types";
import { GraphColor, GraphType } from "@services/monitoring/types";
import { TFunction } from "react-i18next";

export const defaultStatusLabel: [DeviceStatusType, string] = [
  "unknown",
  "Unknown",
];
export const getStatusLabel = (
  device?: Pick<Device, "id">,
  meeting?: MeetingInstance
) => {
  const participant = meeting?.participants?.find(
    (participant) => participant.device?.id === device?.id
  );

  return participant !== undefined && device !== undefined
    ? getStatus(participant, meeting)
    : defaultStatusLabel;
};

const graphTypeTitleKey: Partial<Record<GraphType, string>> = {
  Jitter_Audio: "Jitter",
  Jitter_Video: "Jitter",
  Jitter_Content: "Jitter",
  Frame_Rate: "Speed",
  Ping_Latency: "Ping Latency",
  Call_Rate: "Bitrate",
  Packet_Loss: "Packet Loss",
};

export const getColorGraph = (type: GraphType) => {
  switch (type) {
    case GraphType.Ping_Latency:
      return GraphColor.pink;
    case GraphType.Frame_Rate:
      return GraphColor.purple;
    case GraphType.Packet_Loss:
      return GraphColor.green;
    case GraphType.Call_Rate:
      return GraphColor.teal;
    default:
      return GraphColor.mustard;
  }
};

export const getGraphTitle = (type: GraphType, t: TFunction) => {
  const translationKey = graphTypeTitleKey[type] as string;

  return t(translationKey);
};
